<template>
  <v-stepper
    v-model="passoAtual"
    class="mt-2 mt-md-5"
    style="box-shadow: none;"
  >
    <v-stepper-header
      class="grey lighten-3"
      style="box-shadow: none;"
    >
      <template v-for="(item, index) in quantDePassos">
        <v-stepper-step
          :key="'step_' + index"
          :step="item.step"
          :complete="passoAtual > item.step"
          complete-icon="check"
          :data-cy="'passo_marcador_' + item.step"
        />

        <v-divider
          v-if="quantDePassos.length > item.step"
          :key="'divider_' + index"
        />
      </template>
    </v-stepper-header>

    <v-stepper-items
      class="grey lighten-3"
    >
      <template v-for="(item, index) in quantDePassos">
        <v-stepper-content
          :key="'content_' + index"
          :step="item.step"
          :class="$vuetify.breakpoint.smAndDown ? 'height-content' : 'padding-b'"
          class="pa-0"
        >
          <PassoDadosCompra v-if="item.step === 1" />
          <PassoConferirDadosBancarios
            v-if="item.step === 2"
            :dados-bancarios="dadosBancarios"
            @mudarDadosBancarios="mudarDados"
          />
          <PassoSobreReembolso
            v-if="item.step === 3"
            class="pb-md-5"
            :boleto-parcelado="dadosCompra.is_boleto_in_installments"
            @formValidado="ativarPasso($event,index)"
          />

          <div
            :class="$vuetify.breakpoint.mdAndUp
              ? 'botoes-rodape--desktop' : 'botoes-rodape--mobile botoes-rodape--stepper'"
            class="botoes-rodape --reembolso pa-3 pa-md-0 px-md-0"
          >
            <BtnVoltar
              :key="'voltar_' + index"
              :index="item.step"
              @irParaAnterior="novoValor => passoAtual = novoValor"
            />

            <BtnProsseguir
              v-if="item.step < 3"
              :key="'prosseguir_' + index"
              :index="item.step"
              :desabilitar-btn="item.possuiValidacao && !item.validado"
              @irParaProximo="novoValor => passoAtual = novoValor"
            />

            <BtnEnviar
              v-else
              :dados-reembolso="dadosReembolso"
              :anexos="anexos"
              :desabilitar-btn="item.possuiValidacao && !item.validado"
              @respostaApi="showModal"
            />

            <ModalSolicitarReembolso
              v-if="item.step === 3"
              :dialog="dialog"
              :resposta-success="respostaApi"
              :produtor="nomeProdutor"
            />
          </div>
        </v-stepper-content>
      </template>
    </v-stepper-items>
  </v-stepper>
</template>

<script>

import { mapGetters } from 'vuex';
import PassoDadosCompra from '@/components/SolicitacaoReembolso/PassoDadosCompra.vue';
import PassoConferirDadosBancarios from '@/components/SolicitacaoReembolso/DadosBancarios/PassoConferirDadosBancarios.vue';
import PassoSobreReembolso from '@/components/SolicitacaoReembolso/PassoSobreReembolso.vue';
import BtnProsseguir from '@/components/Steppers/BtnProsseguir.vue';
import BtnEnviar from '@/components/SolicitacaoReembolso/BtnEnviar.vue';
import BtnVoltar from '@/components/Steppers/BtnVoltar.vue';
import ModalSolicitarReembolso from '@/components/SolicitacaoReembolso/ModalSolicitarReembolso.vue';

export default {
  name: 'DadosBancariosStepper',

  components: {
    PassoDadosCompra,
    PassoConferirDadosBancarios,
    PassoSobreReembolso,
    BtnProsseguir,
    BtnEnviar,
    BtnVoltar,
    ModalSolicitarReembolso,
  },

  props: {
    dadosBancarios: {
      type: Object,
      required: true,
    },
    iniciarPasso: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      passoAtual: 1,
      btAtualDisabled: true,
      dadosReembolso: {
        venda: null,
        is_boleto: null,
        nomeFavorecido: null,
        fieldCpfCnpj: null,
        bankCode: null,
        tipoConta: null,
        agencyNumber: null,
        agencyCheckNumber: null,
        accountNumber: null,
        accountCheckNumber: null,
        operacaoVariacao: null,
        accepted_terms: null,
        category_reembolso: null,
        observacoes: null,
        is_credit_card: null,
        is_online_debt: null,
      },
      dialog: false,
      respostaApi: false,
      nomeProdutor: '',
      anexos: [],
      dadosVenda: {
        venda: '',
        is_credit_card: '',
        is_debit_card: '',
        is_boleto: '',
        category_reembolso: '',
        is_online_debt: '',
      },
      quantDePassos: [
        {
          step: 1, form: {}, possuiValidacao: false, validado: false,
        },
        {
          step: 2, form: {}, possuiValidacao: false, validado: false,
        },
        {
          step: 3, form: {}, possuiValidacao: true, validado: false,
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),

    dadosBanco() {
      const objDadosBancarios = {};

      objDadosBancarios.nomeFavorecido = this.dadosBancarios.full_name;
      objDadosBancarios.fieldCpfCnpj = this.dadosBancarios.federal_tax_number;
      objDadosBancarios.bankCode = this.dadosBancarios.bank_code;
      objDadosBancarios.tipoConta = this.dadosBancarios.account_type;
      objDadosBancarios.agencyNumber = this.dadosBancarios.bank_branch;
      objDadosBancarios.agencyCheckNumber = this.dadosBancarios.bank_branch_suffix;
      objDadosBancarios.accountNumber = this.dadosBancarios.account_number;
      objDadosBancarios.accountCheckNumber = this.dadosBancarios.account_number_suffix;
      objDadosBancarios.operacaoVariacao = this.dadosBancarios.operation_type;
      objDadosBancarios.accepted_terms = true;

      return objDadosBancarios;
    },
  },

  watch: {
    passoAtual() {
      this.montarObjeto();
    },

    quantDePassos: {
      handler() {
        this.montarObjeto();
      },
      deep: true,
    },
  },

  mounted() {
    this.setDadosVenda();
    this.setPassoAtual();
    this.nomeProdutor = this.dadosCompra.vendedor || '';
  },

  methods: {
    setDadosVenda() {
      this.dadosVenda.venda = `${this.dadosCompra.venda}`;
      this.dadosVenda.is_credit_card = this.dadosCompra.cartaoCredito;
      this.dadosVenda.is_debit_card = this.dadosCompra.cartaoDebito;
      this.dadosVenda.is_boleto = this.dadosCompra.boleto;
      this.dadosVenda.is_online_debt = this.dadosCompra.is_online_debt;
      this.dadosVenda.category_reembolso = this.dadosCompra.category;
      this.quantDePassos[0].form = this.dadosVenda;
    },

    setPassoAtual() {
      if (this.iniciarPasso === 2) {
        this.passoAtual = this.iniciarPasso;
      }
    },

    ativarPasso(dadosForm, indexArray) {
      this.quantDePassos[indexArray].validado = dadosForm.validado;
      this.quantDePassos[indexArray].form = dadosForm.form;
    },

    montarObjeto() {
      if (this.passoAtual === 3 && this.quantDePassos[2].validado) {
        const passoUm = this.quantDePassos[0].form;
        const passoDois = this.dadosBanco;
        const passoTres = this.quantDePassos[2].form;
        Object.assign(this.dadosReembolso, passoUm, passoDois, passoTres);
        this.anexos = passoTres.anexos;
      }
    },

    showModal(resposta) {
      this.dialog = true;
      this.respostaApi = resposta;
    },

    mudarDados(v) {
      this.$emit('mudarDadosBancarios', v);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/scss/botoes-fixos.scss';
</style>
